'use client';

import { useEffect, useRef } from 'react';
import type { GearVsTier } from '@roomtreatment/seo-content';
import { EVENTS, track } from '@/lib/analytics';

interface Props {
  aId: string;
  bId: string;
  tier: GearVsTier;
}

/** Fires `gear_vs_viewed` once per page view. Renders nothing. */
export default function GearVsViewed({ aId, bId, tier }: Props) {
  // Guards React's development double-invoke; a client-side navigation to
  // another pair changes the key and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    const key = `${aId}|${bId}`;
    if (sent.current === key) return;
    sent.current = key;
    track(EVENTS.gear_vs_viewed, { a_id: aId, b_id: bId, tier });
  }, [aId, bId, tier]);
  return null;
}
